module.exports = __webpack_public_path__ + "img/DHI_Tele.c32c3fb3.png";